import { getScopedClient } from './supabase';

export interface WebinarStatusData {
  id: string;
  title: string;
  subtitle: string;
  status: string;
  launch_status: string;
  launched_at: string | null;
  paused_at: string | null;
  cancelled_at: string | null;
  webinar_date: string;
  webinar_time: string;
  registration_link: string;
  landing_page_theme: string;
  presenter_image: string;
  created_at: string;
  updated_at: string;
}

export async function getWebinarStatus(webinarId: string): Promise<WebinarStatusData | null> {
  const client = getScopedClient();
  const { data, error } = await client
    .from('webinars')
    .select(
      'id, title, subtitle, status, launch_status, launched_at, paused_at, cancelled_at, webinar_date, webinar_time, registration_link, landing_page_theme, presenter_image, created_at, updated_at'
    )
    .eq('id', webinarId)
    .single();

  if (error || !data) return null;
  return data as unknown as WebinarStatusData;
}

export async function updateLaunchStatus(
  webinarId: string,
  status: 'launched' | 'paused' | 'cancelled'
): Promise<void> {
  const updates: Record<string, unknown> = { launch_status: status };

  if (status === 'launched') {
    updates.launched_at = new Date().toISOString();
    updates.paused_at = null; // Clear paused_at when resuming
  }
  if (status === 'paused') {
    updates.paused_at = new Date().toISOString();
  }
  if (status === 'cancelled') {
    updates.cancelled_at = new Date().toISOString();
  }

  const { error } = await getScopedClient()
    .from('webinars')
    .update(updates)
    .eq('id', webinarId);

  if (error) {
    throw new Error(`Failed to update launch status: ${error.message}`);
  }
}
